import { Textarea } from '@frontapp/ui-kit';
import { omit } from 'lodash-es';
import type { FieldProps } from '../FieldWrapper';

export type Value = unknown;

export function JsonInput({
  disabled,
  field,
  ...props
}: FieldProps<Value> & { rows?: number }) {
  return (
    <>
      <Textarea
        id={field.name}
        {...omit(props, ['form', 'meta'])}
        {...field}
        onChange={(value) => {
          try {
            field.onChange(JSON.parse(value));
          } catch (e) {
            // NOP
          }
        }}
        isDisabled={disabled}
        value={JSON.stringify(field.value, null, 2)}
      />
    </>
  );
}
